export const analyticsConstant = {
  PATIENT_VISIT: "PATIENT_VISIT",
  MEDICINE_SALE: "MEDICINE_SALE",
  SERVICE_SALE: "SERVICE_SALE",
  SEARCH: "SEARCH",
  PATIENT_STATUS_FILTER: "PATIENT_STATUS_FILTER",
  PATIENT_SEARCH: "PATIENT_SEARCH",
  PATIENT_DATE_FILTER: "PATIENT_DATE_FILTER",
  SALE_RETURN: "SALE_RETURN",
  REPORT: "REPORT",
  API_TIME: "API_TIME",
};
